// To parse this data:
//
//   import { Convert } from "./file";
//
//   const proyectosLoteListaPrecios = Convert.toProyectosLoteListaPrecios(json);

export class ModeloEquipamiento {
    idProyecto: number;
    idEquipamientoAdicional: number;
    idModelo: number;
    nombreModelo: string;
    nombreEquipamiento: string;
    incremento: number;
    numeroDeLista: number;
    algoritmo: number;
    unidadesMinimas: number;
    unidadesMaximas: number;
    estatus: number;
    tipo: string;
    fechaHoraUM: Date;
    idUsuarioUM: number;
}

// Converts JSON strings to/from your types
export class Convert {
    public static toModelosEquipamientos(json: string): ModeloEquipamiento[] {
        return JSON.parse(json);
    }

    public static modelosEquipamientos(value: ModeloEquipamiento[]): string {
        return JSON.stringify(value);
    }
}
